import { render, staticRenderFns } from "./design-details.vue?vue&type=template&id=65d79c4e&scoped=true&"
import script from "./design-details.vue?vue&type=script&lang=js&"
export * from "./design-details.vue?vue&type=script&lang=js&"
import style0 from "./design-details.vue?vue&type=style&index=0&id=65d79c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d79c4e",
  null
  
)

export default component.exports